@if (!data.refund) {
  <h3>Kontantbetalning</h3>
}
@if (data.refund) {
  <h3>Återbetalning</h3>
}

<div mat-dialog-content>
  @if (!data.refund && !amountEntered) {
    <p>Att betala: {{data.order.amountToPay}} kr</p>
  }
  @if (data.refund && !amountEntered) {
    <p>Max summa för återbetalning: {{data.maxRefund}} kr</p>
  }

  @if (cashForm) {
    <form [formGroup]="cashForm" spellcheck="false">
      @if (!amountEntered) {
        <mat-form-field class="input-field">
          @if (!data.refund) {
            <mat-label>Mottagen summa</mat-label>
          }
          @if (data.refund) {
            <mat-label>Summa att återbetala</mat-label>
          }
          <input matInput formControlName="receivedAmount" autocomplete="off">
          <mat-error>Ogiltigt belopp</mat-error>
        </mat-form-field>
      }
      @if (!amountEntered && data.refund) {
        <mat-form-field class="input-field">
          <mat-label>Anledning till återköp</mat-label>
          <input matInput type="text" autocomplete="off" formControlName="refundComment">
          <mat-error>Kommentar krävs</mat-error>
        </mat-form-field>
      }
      @if (cashForm.hasError('whitespace')) {
        <div>Ange giltig information</div>
      }
    </form>
  }

  @if (amountEntered && !data.refund) {
    <div>
      <p>Betalning genomförd</p>
      <p>Att betala: {{data.order.amountToPay}} kr</p>
      <p>Mottaget belopp: {{cashForm && cashForm.controls['receivedAmount'].value || 0}} kr</p>
      <p>Växel: {{toReturn}} kr</p>
    </div>
  }

  @if (data.refund && amountEntered) {
    <div>
      <p>Återbetalning genomförd!</p>
    </div>
  }

  <!-- Close/confirm -->
  <div mat-dialog-actions class="dialogActions">
    @if (!amountEntered) {
      <button mat-button (click)="closeDialog()">
        Avbryt
      </button>
    }

    @if (!amountEntered) {
      <button mat-button class="button" [ngClass]="{'loading': loading}" (click)="enterAmount()"
        [disabled]="!cashForm?.valid || loading">
        @if (!data.refund) {
          <span>Beräkna växel</span>
        }
        @if (data.refund) {
          <span>Genomför återbetalning</span>
        }
        @if (loading) {
          <mat-spinner diameter="25" color="accent"></mat-spinner>
        }
      </button>
    }

    @if (amountEntered) {
      <button mat-button (click)="closeDialog()">
        Stäng
      </button>
    }

    @if (amountEntered) {
      <button mat-button class="button" (click)="closeAndPrintReceipt()">
        Skriv ut kvitto
      </button>
    }
  </div>
</div>